
/* injects from baggage-loader */

'use strict';

import AlertController from '../alert/alert.controller';

import { failText, letters, rowsNumbers } from './quiz-tamandua-b.const';

import { take, findIndex, filter } from 'lodash';

export default class DialogQuizTamanduaBController extends AlertController{
    constructor($log, $rootScope, $timeout, Dialog) {
        'ngInject';
        super($log, $rootScope);
        
        this.$timeout = $timeout;
        this.Dialog = Dialog;

        this.letters = take(letters.split(""), 10);
        this.rowsNumbers = rowsNumbers.split("");
        
        this.answers = [];
    }

    $onInit(){
        this.answers = this.mountAnswers()
    }
    
    validate(){
        angular.forEach(this.answers, a => {
            if(angular.isObject(a.item)){
                let inputPosition = this.getPosistion(a.value);
                let itemPosition = a.item.position;
                a.error = ( inputPosition.x !== itemPosition.x ) || ( inputPosition.y !== itemPosition.y );
            } else {
                a.error = parseInt(a.value) !== this.getTotalSteps();
            }
        });

        return filter(this.answers, { error: true }).length ? false : true;
    }

    mountAnswers(){        
        let { items } = this.resolve.model;

        let itemA = items[0].objects[0];
        let itemB = items[1].objects[0];
        let itemC = items[2].objects[0];
        
        let answers = [
            {
                type: 'a1',
                value: null,
                item: items[0],
                error: false,
                text: `Em qual posição se encontra ${ itemA.label }?`
            },
            {
                type: 'a2',
                value: null,
                item: items[1],
                error: false,
                text: `Em qual posição se encontra ${ itemB.label }?`
            },
            {
                type: 'a3',
                value: null,
                item: items[2],
                error: false,
                text: `Em qual posição se encontra ${ itemC.label }?`   
            }
        ]

        return answers;
    }

    onSubmit(form) {
        if (form.$invalid) return;
        return this.validate() ? this.onValidateSuccess() : this.Dialog.showAlert('label-opa', failText);
    }

    onValidateSuccess(){
        this.$timeout(this.ok.bind(this), 200);
        
        /*
        this.Dialog.showFeedback('label-very-good', successText, 'btn-continue', () => {
            this.$timeout(this.ok.bind(this), 200);
        });
        */
    }

    getPosistion(str){
        let result = str.split("");
        let indexOfLetters = findIndex(this.letters, l => result[0].toLowerCase() === l);
        let indexOfRows = findIndex(this.rowsNumbers, r => result[1].toLowerCase() === r);

        let position = {
            x: ( indexOfLetters + 1 ),
            y: ( indexOfRows + 1 )
        };

        return position
    }

    getTotalSteps(){
        let totalEvents = 0;

        if (!this.resolve.model.player) return totalEvents;

        angular.forEach(this.resolve.model.player.events, position => {
            totalEvents += position;
        });

        return totalEvents;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/quiz-tamandua-b/quiz-tamandua-b.controller.js